import ModelTypeConstants from 'constants/ModelTypeConstants';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getLatestStepVersion} from 'pipelines/StepConnectionUtils';

import {ParseClipboardContentFn} from './CopyPasteTypes';
import {parseApiIdsClipboardContent} from './parseApiIdsClipboardContent';

/** @package */
export const parseFileIdsClipboardContent: ParseClipboardContentFn = (_pipelineId, text) => {
  const fileIds = parseApiIdsClipboardContent(text, ModelTypeConstants.FILE);
  if (fileIds == null) {
    return Promise.resolve(null);
  }
  return Promise.resolve([
    {
      stepType: PipelineStepType.DATA_CATALOG_FILES,
      stepVersion: getLatestStepVersion(PipelineStepType.DATA_CATALOG_FILES),
      config: {fileIds, fileBaseName: 'Pasted files'},
      incomingEdges: [],
      runAfterCreate: true,
    },
  ]);
};
